import {
    GET_PRODUCT,
    GET_PRODUCT_SUCCESS,
    GET_PRODUCT_FAILURE,
    UPDATE_PRODUCT_STATUS,
    UPDATE_PRODUCT_STATUS_SUCCESS,
    UPDATE_PRODUCT_STATUS_FAILURE,
    UPDATE_PRODUCT_ORDER_STATUS,
    UPDATE_PRODUCT_ORDER_STATUS_SUCCESS,
    UPDATE_PRODUCT_ORDER_STATUS_FAILURE,
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ADD_PRODUCT_FAILURE,
    EDIT_PRODUCT,
    EDIT_PRODUCT_SUCCESS,
    EDIT_PRODUCT_FAILURE,
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
} from "../Constants";

export const GetProduct = (payload) => ({
    type: GET_PRODUCT,
    payload
});

export const GetProductSuccess = (payload) => ({
    type: GET_PRODUCT_SUCCESS,
    payload
});

export const GetProductFailure = (payload) => ({
    type: GET_PRODUCT_FAILURE,
    payload
});

export const UpdateProductStatus = (payload) => ({
    type: UPDATE_PRODUCT_STATUS,
    payload
});

export const UpdateProductStatusSuccess = (payload) => ({
    type: UPDATE_PRODUCT_STATUS_SUCCESS,
    payload
});

export const UpdateProductStatusFailure = (payload) => ({
    type: UPDATE_PRODUCT_STATUS_FAILURE,
    payload
});

export const UpdateProductOrderStatus = (payload) => ({
    type: UPDATE_PRODUCT_ORDER_STATUS,
    payload
});

export const UpdateProductOrderStatusSuccess = (payload) => ({
    type: UPDATE_PRODUCT_ORDER_STATUS_SUCCESS,
    payload
});

export const UpdateProductOrderStatusFailure = (payload) => ({
    type: UPDATE_PRODUCT_ORDER_STATUS_FAILURE,
    payload
});

export const AddProduct = (payload) => ({
    type: ADD_PRODUCT,
    payload
});

export const AddProductSuccess = (payload) => ({
    type: ADD_PRODUCT_SUCCESS,
    payload
});

export const AddProductFailure = (payload) => ({
    type: ADD_PRODUCT_FAILURE,
    payload
});

export const EditProduct = (payload) => ({
    type: EDIT_PRODUCT,
    payload
});

export const EditProductSuccess = (payload) => ({
    type: EDIT_PRODUCT_SUCCESS,
    payload
});

export const EditProductFailure = (payload) => ({
    type: EDIT_PRODUCT_FAILURE,
    payload
});

export const DeleteProduct = (payload) => ({
    type: DELETE_PRODUCT,
    payload
});

export const DeleteProductSuccess = (payload) => ({
    type: DELETE_PRODUCT_SUCCESS,
    payload
});

export const DeleteProductFailure = (payload) => ({
    type: DELETE_PRODUCT_FAILURE,
    payload
});

